import { cn, Icon, type TableColumn, TableSort } from "@kyan/ui";

import { tooltips } from "#/config/tooltips";
import { type OpenOrder } from "#/types/orders";
import { isMaturity, parseMaturity } from "#/utils/maturity";

import { commonColumns } from "../../OpenOrders.constants";
import { CancelAllOrders } from "../CancelAllOrders/CancelAllOrders";
import { Instrument } from "../Instrument/Instrument";

export const defaultSort: TableSort<OpenOrder> = {
  key: "instrument",
  order: "asc",
};

const emptyColumns: TableColumn<OpenOrder>[] = [
  {
    id: "size",
    header: "Size",
  },
  {
    id: "direction",
    header: "Direction",
  },
  {
    id: "limitPrice",
    header: "Limit Price",
    tooltip: tooltips.limitPrice,
  },
  {
    id: "filled",
    header: "Filled",
    tooltip: tooltips.filled,
  },
  {
    id: "orderId",
    header: "Order ID",
    minWidth: "150px",
    tooltip: tooltips.orderId,
  },
  {
    id: "tif",
    header: "TIF",
    tooltip: tooltips.tif,
  },
  {
    id: "data",
    header: "Date created",
    minWidth: "75px",
    tooltip: tooltips.data,
  },
  {
    id: "cancel",
    minWidth: "75px",
    header: <CancelAllOrders />,
  },
].map((column) => ({
  ...column,
  cellClassName: "text-textSecondary",
  cell: () => "-",
}));

export const outerColumns: TableColumn<OpenOrder>[] = [
  {
    id: "instrument",
    header: "Instrument",
    minWidth: "260px",
    cellClassName: "pl-10",
    columnClassName: "pl-10",
    sort: true,
    cell: (row, { isRowOpen }) => (
      <div className="flex min-w-24 items-center justify-between gap-4">
        <span className="group-last:text-textSecondary">
          {isMaturity(row.instrument)
            ? `${parseMaturity(row.instrument)} (${row.subOpenOrders?.length})`
            : row.instrument}
        </span>
        <Icon
          name="caret-up"
          className={cn(
            "text-xxs rotate-90 transition-transform group-last:hidden",
            {
              "rotate-180": isRowOpen,
            },
          )}
        />
      </div>
    ),
  },
  ...emptyColumns,
];

export const innerColumns: TableColumn<OpenOrder>[] = [
  {
    id: "instrument",
    header: "Instrument",
    minWidth: "260px",
    cellClassName: "sm:pl-15",
    columnClassName: "sm:pl-15",
    cell: ({ instrument }) => <Instrument instrument={instrument} />,
  },
  ...commonColumns,
];
